var _defs, _path, _path2, _path3, _path4, _path5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNsaqIconAtc(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .adc-cls-1 {\n        ", "\n        stroke-width: 0px;\n      }\n\n      .adc-cls-2 {\n        \n        stroke-linejoin: round;\n      }\n\n      .adc-cls-2, .adc-cls-3 {\n        fill: none;\n        ", "\n        stroke-linecap: round;\n        stroke-width: 1.5px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "adc-cls-2",
    d: "M1.27,3.44h2.37l.71,3.16,1.53,6.81h11.04l1.82-6.17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "adc-cls-1",
    d: "M8.26,18.36c.85,0,1.54-.69,1.54-1.54s-.69-1.54-1.54-1.54-1.54.69-1.54,1.54.69,1.54,1.54,1.54Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "adc-cls-1",
    d: "M14.52,18.36c.85,0,1.54-.69,1.54-1.54s-.69-1.54-1.54-1.54-1.54.69-1.54,1.54.69,1.54,1.54,1.54Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "adc-cls-3",
    d: "M11.64,1.64v6.86"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "adc-cls-3",
    d: "M15.07,5.07h-6.86"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNsaqIconAtc);
export default __webpack_public_path__ + "static/media/nsaq-icon-atc.4a48df67edf2a8511f9569b408a6aed4.svg";
export { ForwardRef as ReactComponent };